const STORAGE_KEY_PREFIX = 'expense-file-rotation:'
const ROTATION_STEP = 90
const MAX_ROTATION = 360

export const getStorageKey = (fileId: string): string => `${STORAGE_KEY_PREFIX}${fileId}`

export const getStoredRotation = (fileId: string | null): number => {
  if (!fileId) return 0

  try {
    const stored = localStorage.getItem(getStorageKey(fileId))
    const rotation = stored ? Number(stored) : 0
    return isNaN(rotation) ? 0 : rotation % MAX_ROTATION
  } catch {
    return 0
  }
}

export const storeRotation = (fileId: string | null, rotation: number): void => {
  if (!fileId) return

  try {
    const normalizedRotation = rotation % MAX_ROTATION
    if (normalizedRotation === 0) {
      localStorage.removeItem(getStorageKey(fileId))
    } else {
      localStorage.setItem(getStorageKey(fileId), String(normalizedRotation))
    }
  } catch {
    // localStorage may be unavailable (private browsing, quota exceeded, etc.)
  }
}

export const getNextRotation = (current: number): number => (current + ROTATION_STEP) % MAX_ROTATION
